// START Open Requre.JS wrapper
define(["jquery",
		"wcs.context",
        "wcs.product-price-util", "wcs.product-price-ajax"],
		function($, ctx, priceContainerUtil, pricePromise){

	var DEBUG = false;

	var that = {};

	that.init = function($productForm) {
		if ( DEBUG )  console.log("Initializing WCS Product Price Service");

		// make this context available to inner functions of init()
		var self = this;

		if( !$productForm){
            self.$productForm = $('.product-form-js');
        }
		else {
            self.$productForm = $productForm;
        }

		that.$productForm 				= self.$productForm;
		that._isColorBundle 			= null;
		that._isProductBundle 			= null;
		that._bundlePartNumber			= null;
		that._productId 				= [];
		that._attrId 					= [];
		that._itemPricingJSONCache 		= window.itemPrices || {};
		that._isBuyable 				= [];
		that._possibleProducts 			= [];
		that._isListenersSet 			= false;
		that._isInitialized 			= false;
		that._lastClickedElement 		= null;
		that._fetchQueue 				= [];
		that._fetchPointer 				= 0;
		that._retryCount 				= [];
		that._firstLoad 				= WCS_CONFIG.get('PDP::ignoreSelectionOnFirstLoad');
		that.DEFAULT_RETRY_COUNT 		= 5;

        // product pricing levels:
        that.productCandidates 			= [];
        that.price 						= null;
        that.listPrice 					= null;
        that.lowPrice 					= null;
        that.highPrice 					= null;
        that.lowListPrice 				= null;
        that.highListPrice 				= null;
        that.lowPriceNumeric 			= 0;
        that.highPriceNumeric 			= 0;
        that.lowListPriceNumeric 		= 0;
        that.highListPriceNumeric 		= 0;

        that.metadata = this.$productForm.data('product-pricing-options');

        that.productFormIndex = $('.product-form-js').index(this.$productForm);


		self.config = $.extend({}, self.defaults, self.options, self.metadata);


		self._isColorBundle = self.$productForm.find(".selection-js [data-product-id]").length || $('.context-trigger-js').length !== 0;
		self._bundlePartNumber = self.$productForm.data('bundle-part-number') || null;
		self._isProductBundle = self._multipleProductFormsPresent = $('.product-form-js').length > 1;

		return self;
	};

	that.parseProductFormAttributes = function () {

		if ( DEBUG ) console.log('parseProductFormAttributes');

		var self = this;

		self.$productForm.each(function(index) {
			var $this = $(this),
				$productPrice = that._getProductPriceContainer(index);

			that._productId[index] = $this.find('input[name=catEntryId]').val();
			that._attrId[index] = $this.find('input[name=attrName]').val();
			that._possibleProducts[index] = [];
			that._isBuyable[index] = true;
			that._retryCount[index] = self.DEFAULT_RETRY_COUNT;

			if($productPrice.length) {
				that._handleItemPricing(index, that._productId[index]);
			}

		});

		return this;
	};

	that._getProductPriceContainer = function(index){

		if ( DEBUG ) console.log('_getProductPriceContainer');

		var self = this;
		if(self._isProductBundle) {
			return $(".price-container-js").eq(index).find("> .product-price-js");
		} else {
			return $("#product-info .product-price-js, .price-container-js .product-price-js").eq(index);
		}
	};

	that._getProductIdFromURLParameter = function () {
		return ctx.getParameterByName('productId');
	};

	that._getPricingByProductID = function (index, productId) {
		if( !that._initialPriceFetched ){ // This should be executed only on the first load, and not on color click. There is no way to change productId, so subsequent calls cannot be parameteraized with different productId's
			pricePromise.done(function(data) { //In case of PDP, there is an early ajax call, so the promise would be resolved and ready - containing the prices.
				that._handleSuccessDataReturn(index, productId, data);
				that._initialPriceFetched = true;
			}).fail(function(error) {
				that._makeAnAjax(index, productId);
			});
		}
		else {
			that._makeAnAjax(index, productId);
		}
	};

	that._makeAnAjax = function(index, productId){
		var jsonPricingURL = that.$productForm.data('priceUrl');

		if((typeof jsonPricingURL !== "undefined") && !!productId) {
			var ajaxPromise = $.ajax({
				url: ctx.getURLWithContextRoot(jsonPricingURL),
				data: {
					storeId: ctx.getStoreId(),
					langId: ctx.getLangId(),
					catalogId: ctx.getCatalogId(),
					productId: productId
				}
			});
			that._handlePromise(ajaxPromise, index, productId);
		}
	};

	that._handlePromise = function(ajaxPromise, index, productId){
		ajaxPromise.done(function(data){
			that._handleSuccessDataReturn(index, productId, data);
		}).fail(function(){
			that._handleErrorReturn(index, productId);
		});
	};

	that._handleSuccessDataReturn = function(index, productId, data) {

			if ( DEBUG ) console.log('_handleSuccessDataReturn');

			var self = this;

			if(data === '') // Try again if data is empty
				self._handleErrorReturn(index, productId);
			self._itemPricingJSONCache[productId] = data;
			self._handleItemPricing(index, productId);
		};

	that._handleErrorReturn = function(index, productId){

			if ( DEBUG ) console.log('_handleErrorReturn');

			var self = this;

			// Try getting the price again
			if(self._retryCount[index] === 0) {
				return true;
			} else {
				self._retryCount[index]--;
				self._getPricingByProductID(index, productId);
			}
		};

	that._handleItemPricing = function(index, productId){

			if ( DEBUG ) console.log('_handleItemPricing');

			var self = this,
				data;

			if(!self._itemPricingJSONCache.hasOwnProperty(productId)) {
				self._getPricingByProductID(index, productId);
				return;
			} else {
				data = self._itemPricingJSONCache[productId];
				that._initialPriceFetched = true;
			}

			self._isInitialized = true;

			// update _isBuyable flag
			if(typeof data.buyable !== "undefined") {
				self._isBuyable[index] = data.buyable;
			}

			if(self._isBuyable[index] === true) {
				// show default pricing if buyable flag is true
				self._resetPrice(index);
				// that._refreshProductPrice(index);

			} else {
				// show no pricing html if buyable flag is false
				self._showProductPrice(index, null);
			}

			if ( self._getProductIdFromURLParameter() ){
				self._resetPrice(index);
				// that._refreshProductPrice(index);
			}
		};

    that._getNewAttributeSelections = function(index){

        if ( DEBUG ) console.log('_getNewAttributeSelections');

        var self = that;
        self.$productForm.eq(index).find(".attr-box.selected:visible").each(function(){
            var attrValue = $(this).data("attribute-value"),
                attrId = $(this).closest(".selection-js").data("attribute-id");
            
            if( WCS_CONFIG.get('PDP::pdpPriceUseColorCodeEnabled')) {
            	attrValue = $(this).data("color-identifier");
            }

            // for color bundle attributes, attrId is stored elsewhere
            if(typeof attrId === "undefined") {
                attrId = self._attrId[index];
            }

            that.handleAttrInputChange(index, attrId, attrValue, -1);
        });

        self.$productForm.eq(index).find(".attr-input-js option:selected").each(function(){
            var attrValue 	= $(this).data("attribute-value"),
                attrId 		= $(this).closest(".selection-js").data("attribute-id");

            // for color bundle attributes, attrId is stored elsewhere
            if(typeof attrId === "undefined") {
                attrId = self._attrId[index];
            }

            self.handleAttrInputChange(index, attrId, attrValue, -1);
        });
    };

    // calculate pricing based on current attribute selections
    that._resetPrice = function(index) {

        if ( DEBUG ) console.log('_resetPrice');

        var self = that;
        self._possibleProducts[index] = [];
        if(self._firstLoad === true) {
            self._firstLoad = false;
        }else{
            self._getNewAttributeSelections(index);
        }
        self._refreshProductPrice(index);
    };

	that.loadPriceValues = function(priceContainer, pricingObj){

		if ( DEBUG ) console.log('loadPriceValues');

		var util = new priceContainerUtil(priceContainer),
			temp,
			tempPrice,
			priceNumeric = [],
			listPriceNumeric,
			noSaleOnHighListPrice = false;

		if(typeof pricingObj === 'undefined' || pricingObj === null){

			util.updatePriceHTML(setToZero = true, undefined);
			util.hideAllPrices();
		} else {
			var price,
				listPrice,
				dataAmountPrice;

			if(pricingObj.lowPriceNumeric == pricingObj.highPriceNumeric) {
				price = pricingObj.lowPrice;
				priceNumeric[0] = pricingObj.lowPriceNumeric;

			} else {

				// show highPrice as default text color if equal to highList price
				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled')  && ( pricingObj.highPriceNumeric === pricingObj.highListPriceNumeric ) ) {
					price = pricingObj.lowPrice + " <bdi>- " + pricingObj.highPrice + "</bdi>";
					noSaleOnHighListPrice = true;
				} else {
					price = pricingObj.lowPrice + " - " + pricingObj.highPrice;
				}

				priceNumeric[0] = pricingObj.lowPriceNumeric;

				// don't create item if high price equals high list price as there's no need to calculate a discount
				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled') && (pricingObj.highPriceNumeric !== pricingObj.highListPriceNumeric) ){
					priceNumeric[1] = pricingObj.highPriceNumeric;
				}
			}
			that.latestPrice = price;

			if(pricingObj.lowListPriceNumeric == pricingObj.highListPriceNumeric) {
				listPrice = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPrice : pricingObj.lowPrice);
				listPriceNumeric = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPriceNumeric : pricingObj.lowPriceNumeric);

			} else {
				var lowListPrice = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPrice : pricingObj.lowPrice);
				var highListPrice = (pricingObj.highPriceNumeric <= pricingObj.highListPriceNumeric ? pricingObj.highListPrice : pricingObj.highPrice);
				if (lowListPrice != highListPrice){
					listPrice = lowListPrice + " - " + highListPrice;
				}
				else{
					listPrice = lowListPrice;
				}

				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled') ){

					// set as array to store range values
					listPriceNumeric = [];

					// only add highPrice if it's less than highListPrice
					if( pricingObj.highPriceNumeric < pricingObj.highListPriceNumeric ){
						listPriceNumeric[0] =  pricingObj.lowListPriceNumeric;
						listPriceNumeric[1] =  pricingObj.highListPriceNumeric;
					}
					else{
						listPriceNumeric[0] =  pricingObj.lowListPriceNumeric;
					}
				}

			}

			dataAmountPrice = pricingObj.lowPriceNumeric;
			util.setDataAmount(dataAmountPrice);
			if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true) {
				if(price != listPrice) {
					temp = 0;
					tempPrice = 0;
					var	listPriceNum,
						tempPriceNum = 0;
					if(price.indexOf("-") > -1){
						temp = price.split("-");
						tempPrice = temp[0].trim();
						tempPriceNum = tempPrice.match(/\d+([\/.]\d+)?/g);
						tempPriceNum = parseFloat(tempPriceNum[0]);
					}
					listPriceNum = listPrice.match(/\d+([\/.]\d+)?/g);
					listPriceNum = parseFloat(listPriceNum[0]);
					if(tempPriceNum >= listPriceNum){
						util.updatePriceHTML(setToZero = true, price);
					}else{
						util.showSalePrice(listPrice, price, priceNumeric, listPriceNumeric, noSaleOnHighListPrice);
					}
				} else if(price == listPrice) {
					util.updatePriceHTML(setToZero = false, price);
				} else {
					util.updatePriceHTML(setToZero = true, undefined);
				}

			}
			else{
				if(price != listPrice) {
					temp = 0;
					tempPrice = 0;
					if(price.indexOf("-") > -1){
						temp = price.split("-");
						tempPrice = temp[0].trim();
					}
					if(tempPrice >= listPrice){
						util.updatePriceHTML(setToZero = true, price);
					}else{
						util.showSalePrice(listPrice, price);
					}
				} else if(price == listPrice) {
					util.updatePriceHTML(setToZero = false, price);
				} else {
					util.updatePriceHTML(setToZero = true, undefined);

				}
			}
		}
	};

    that._showProductPrice = function(index, pricingObj){

                if ( DEBUG ) console.log('_showProductPrice');

                var self = that,
                    productPriceHTML = "",
                    $productPrice = self._getProductPriceContainer(index);

                self.loadPriceValues($productPrice, pricingObj);

                if(WCS_CONFIG.get('PDP::showPriceAboveAddToCart') === true) {
                    var $mobilePrice = $(".product-actions-product-price-container .product-price-js").eq(0);
                    self.loadPriceValues($mobilePrice, pricingObj);
                }
            };

    that._refreshProductPrice = function (index) {

        if (DEBUG) console.log('_refreshProductPrice +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');

        var self = that,
            _productId = self._productId;
        // update pricing text based on attribute selections
        if (self._possibleProducts[index].length === 0) {
            if (typeof self._itemPricingJSONCache[self._productId[index]] !== "undefined") {
                if (DEBUG) console.log("Cached price data exists", self._itemPricingJSONCache, self._productId, index);
                self._showProductPrice(index, self._itemPricingJSONCache[_productId[index]].pricing["default"]);
            } else if (DEBUG) {
                console.warn("Missing cached price data when selecting size context", self._itemPricingJSONCache, self._productId, index);
            }
        } else if (!self._itemPricingJSONCache[_productId[index]].pricing) {
            self._showProductPrice(index, null);
        } else {
            self.getNewProductPricingData(index);
        }
    };

    that.buildProductPriceJSONForRenderingPrice = function(index){

                if ( DEBUG ) console.log('buildProductPriceJSONForRenderingPrice');

                var self = that,
                    priceJSON = {},
                    _productId = self._productId,
                    firstLoop = true;
                // loop through all qualified products for final price range
                for(var j in self.productCandidates) {
                    var productId = self.productCandidates[j],
                        product = self._itemPricingJSONCache[_productId[index]].pricing.sku[productId],
                        productPrice = product.price,
                        productPriceNumeric = product.priceNumeric,
                        productListPrice = product.listPrice,
                        productListPriceNumeric = product.listPriceNumeric;

                    if(firstLoop ) {
                        firstLoop = false;
                        self.lowPrice = productPrice;
                        self.highPrice = productPrice;
                        self.lowListPrice = productListPrice;
                        self.highListPrice = productListPrice;
                        self.lowPriceNumeric = productPriceNumeric;
                        self.highPriceNumeric = productPriceNumeric;
                        self.lowListPriceNumeric = productListPriceNumeric;
                        self.highListPriceNumeric = productListPriceNumeric;
                    }
                    else {
                        if(productPriceNumeric < self.lowPriceNumeric) {
                            self.lowPriceNumeric = productPriceNumeric;
                            self.lowPrice = productPrice;
                        }
                        if(productPriceNumeric > self.highPriceNumeric) {
                            self.highPriceNumeric = productPriceNumeric;
                            self.highPrice = productPrice;
                        }
                        if(productListPriceNumeric < self.lowListPriceNumeric) {
                            self.lowListPriceNumeric = productListPriceNumeric;
                            self.lowListPrice = productListPrice;
                        }
                        if(productListPriceNumeric > self.highListPriceNumeric) {
                            self.highListPriceNumeric = productListPriceNumeric;
                            self.highListPrice = productListPrice;
                        }
                    }
                }

                priceJSON = {
                    "lowPrice": self.lowPrice,
                    "lowPriceNumeric": self.lowPriceNumeric,
                    "highPrice": self.highPrice,
                    "highPriceNumeric": self.highPriceNumeric,
                    "lowListPrice": self.lowListPrice,
                    "lowListPriceNumeric": self.lowListPriceNumeric,
                    "highListPrice": self.highListPrice,
                    "highListPriceNumeric": self.highListPriceNumeric
                };

                return priceJSON;
            };

    that.getNewProductPricingData = function(index){

        if ( DEBUG ) console.log('getNewProductPricingData');

        var self = that;
        // set output product array to be the possible products from the first selected attribute
        self.productCandidates = self._possibleProducts[index][0].sku;

        // loop through all selected attributes, find intersections of products
        for(var i in self._possibleProducts[index]) {
            self.productCandidates = self.arrayIntersection(self.productCandidates, self._possibleProducts[index][i].sku);
        }
        if(self.productCandidates.length > 0) {
            self._showProductPrice(index, that.buildProductPriceJSONForRenderingPrice( index ) );
        } else {
            self._showProductPrice(index, null);
        }
    };

    that.arrayIntersection = function (arrayA, arrayB) {

        if (DEBUG) console.log('arrayIntersection');

        var tmpArray = [];
        for (var i in arrayA) {
            if (arrayB.indexOf(arrayA[i]) > -1) {
                tmpArray.push(arrayA[i]);
            }
        }
        return tmpArray;
    };

            //REFACTOR ME
    that.handleAttrInputChange = function(index, attrId, attrValue, attrIndex){

        if ( DEBUG ) console.log('handleAttrInputChange');

        var self = that,
            _productId 	= self._productId;

        if(typeof attrValue === "undefined" && attrIndex > -1) {
            //user sets the attribute value to empty, needs to reset possible products on that attribute
            if(attrIndex === 0 && self._possibleProducts[index].length === 1) {
                self._possibleProducts[index] = [];
            }
            else if(attrIndex === 0) {
                self._possibleProducts[index][attrIndex].sku = self._possibleProducts[index][1].sku;
            } else {
                self._possibleProducts[index][attrIndex].sku = self._possibleProducts[index][0].sku;
            }
        } else if(typeof attrValue !== "undefined") {
            var tmpSku = [];
            if(typeof self._itemPricingJSONCache[self._productId[index]] !== "undefined"){
                if(typeof self._itemPricingJSONCache[self._productId[index]].pricing[attrId] === "undefined") {
                    // selected attribute is not in the returned pricing json
                    if(typeof self._itemPricingJSONCache[self._productId[index]].pricing.sku !== 'undefined'){
                        $.each(self._itemPricingJSONCache[self._productId[index]].pricing.sku, function(k, v){
                            tmpSku.push(parseInt(k));
                        });
                    }
                } else if( typeof self._itemPricingJSONCache[self._productId[index]].pricing[attrId][attrValue] !== "undefined"){
                    tmpSku = self._itemPricingJSONCache[self._productId[index]].pricing[attrId][attrValue].sku;
                }

                if(attrIndex < 0) {
                    // add the possible skus of the selected attribute into _possibleProducts if it is not already there
                    self._possibleProducts[index].push({
                        "attrId": attrId,
                        "sku": tmpSku
                    });
                } else {
                    // if the attribute has an entry already, update the skus
                    self._possibleProducts[index][attrIndex].sku = tmpSku;
                }
            }
        }
    };


	return that;
	// START close Require.JS wrapper
	}
);
// END close Require.JS wrapper
